import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/certificates.css";

// IMPORTING THE LOCAL CERTIFICATE IMAGE
// Ensure this file exists at: src/assets/images/certificate-1.jpg
import certOne from "../assets/images/IEC.jpg"; 
import certTwo from "../assets/images/RCMC.jpg"; 
import handshakeImage from "../assets/images/handshake.jpg";

const certificatesList = [
  {
    id: "iec",
    title: "Import Export Code (IEC)",
    authority: "Directorate General of Foreign Trade",
    description: "Our primary registration for global trade operations, authorizing Aditya Exports to ship premium coffee beans to any international port.",
    // Thumbnail uses the full image for consistency
    thumb: certOne,
    // Full Image for Popup
    fullImage: certOne, 
    icon: "🌐"
  },
  {
    id: "rcmc",
    title: "RCMC (Coffee Board)",
    authority: "Ministry of Commerce & Industry",
    description: "Specific certification for coffee exports, ensuring adherence to strict quality and trade guidelines of the Indian Coffee Board.",
    thumb: certTwo,
    fullImage: certTwo,
    icon: "☕"
  }
];

export default function Certificates() {
  const [selectedCert, setSelectedCert] = useState(null);
  const [imgError, setImgError] = useState(false);

  // Open Modal
  const openModal = (cert) => {
    setImgError(false); 
    setSelectedCert(cert);
    document.body.style.overflow = 'hidden'; // Lock background scroll
  };

  // Close Modal
  const closeModal = () => {
    setSelectedCert(null);
    document.body.style.overflow = 'auto'; // Restore background scroll
  };

  return (
    <div className="cert-page">
      {/* HEADER SECTION */}
      <section className="cert-hero">
        <div className="container">
          {/* Reverted to original style (See CSS) */}
          <span className="section-label light">Global Compliance</span>
          <h1 className="hero-title">Certified Excellence in <br/> Coffee Exportation</h1>
          <p className="hero-subtitle">
            Aditya Exports Ventures is a legally fortified entity. We maintain rigorous 
            documentation to ensure your international shipments are processed with 
            unmatched speed and transparency.
          </p>
        </div>
      </section>

      {/* CERTIFICATES GALLERY */}
      <section className="cert-grid-section">
        <div className="container">
          <div className="section-header">
            <span className="section-label">Trust & Legitimacy</span>
            <h2 className="section-title">Our Legal Framework</h2>
            <p className="section-subtitle">Official registrations recognized by the Government of India and International Trade Bodies.</p>
          </div>
          
          <div className="cert-grid">
            {certificatesList.map((cert) => (
              <div 
                className="cert-card" 
                key={cert.id} 
                onClick={() => openModal(cert)}
              >
                <div className="cert-img-container">
                  <img src={cert.thumb} alt={cert.title} className="cert-dummy-img" />
                  <div className="cert-img-overlay">
                    <span className="view-text">View Document</span>
                  </div>
                </div>
                <div className="cert-body">
                  <div className="cert-header-meta">
                    <span className="cert-icon-small">{cert.icon}</span>
                    <span className="cert-status">✓ Verified</span>
                  </div>
                  <h3>{cert.title}</h3>
                  <span className="cert-authority">{cert.authority}</span>
                  <p>{cert.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* EXPORT GOVERNANCE */}
      <section className="export-governance">
        <div className="container">
          <div className="governance-card">
            <div className="gov-content">
              <span className="section-label light">Our Protocol</span>
              <h2>Standard Export Governance</h2>
              <p>Every shipment follows a rigorous 3-step legal verification to guarantee origin and safety standards.</p>
              
              <div className="gov-steps">
                <div className="gov-step">
                  <span className="gov-num">01</span>
                  <div>
                    <h4>Origin Verification</h4>
                    <p>Issuance of Certificate of Origin by the Chamber of Commerce for all batches.</p>
                  </div>
                </div>
                <div className="gov-step">
                  <span className="gov-num">02</span>
                  <div>
                    <h4>Phytosanitary Clearance</h4>
                    <p>Health inspections to meet international biosecurity standards for fresh produce.</p>
                  </div>
                </div>
                <div className="gov-step">
                  <span className="gov-num">03</span>
                  <div>
                    <h4>SGS Certified Safety</h4>
                    <p>Fumigation and vacuum sealing treatment for long-haul international shipping.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="gov-image">
               <img src={handshakeImage} alt="Trade Meeting" />
            </div>
          </div>
        </div>
      </section>

      {/* TRUST BANNER */}
      <section className="trust-banner">
        <div className="container">
           <div className="trust-flex">
              <div className="trust-item">
                <span className="trust-count">100%</span>
                <p>Legal Compliance</p>
              </div>
              <div className="trust-item">
                <span className="trust-count">Zero</span>
                <p>Customs Rejections</p>
              </div>
              <div className="trust-item">
                <span className="trust-count">Global</span>
                <p>Trade Eligibility</p>
              </div>
           </div>
        </div>
      </section>

      {/* CTA SECTION */}
      {/* <section className="cert-cta">
        <div className="container text-center">
          <h2 className="section-title">Need Purchase Verification?</h2>
          <p className="section-subtitle mb-5">We provide full transparency. Contact our legal desk for certified copies of our trade documents.</p>
          <div className="cta-btns-group">
            <Link to="/contact" className="btn-orange text-decoration-none">Request Legal Copies</Link>
          </div>
        </div>
      </section> */}

      {/* LUXURY POPUP MODAL */}
      {selectedCert && (
        <div className="cert-modal-overlay" onClick={closeModal}>
          <div className="cert-modal-content" onClick={(e) => e.stopPropagation()}>
            {/* Elegant Close Button */}
            <button className="close-modal-btn" onClick={closeModal} aria-label="Close">
               ✕
            </button>
            
            <div className="cert-modal-header">
              <h3>{selectedCert.title}</h3>
              <span>{selectedCert.authority}</span>
              <div className="gold-divider"></div>
            </div>

            <div className="cert-modal-body">
              {!imgError ? (
                 <img 
                 src={selectedCert.fullImage} 
                 alt={selectedCert.title} 
                 className="cert-full-img"
                 onError={() => setImgError(true)} 
               />
              ) : (
                <div className="cert-not-available">
                   <div className="error-icon">⚠️</div>
                   <h4>Document Not Available</h4>
                   <p>The digital copy of this certificate is currently being updated or is restricted. Please contact support.</p>
                </div>
              )}
            </div>
            
            <div className="cert-modal-footer">
               <span className="verified-badge">Official Document</span>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}